import { Typography } from "@mui/material"
import clsx from "clsx"
import { Key, useEffect, useState } from "react"
import { useAssessmentStore } from "../../shared/store"
import { Question2 } from "../../shared/utils/assessment-types"
import { trackMixpanelEvent } from "../../utils/helpers"
import { ASSET_ASSESSMENT_EVENTS } from "../../shared/constants/MIXAPANEL_EVENTS"

type RenderAssetQuestionTypes = {
    question: Question2
    index: number
    questionsArray: any
    updateNewAnswers: (obj: any) => void
}
const RenderAssetQuestion = ({
    question,
    index,
    questionsArray,
    updateNewAnswers,
}: RenderAssetQuestionTypes) => {
    const { currentStep, screenDetails } = useAssessmentStore((state) => state)
    const [selectedOption, setSelectedOption] = useState("")

    const handleButtonClick = (option: any) => {
        trackMixpanelEvent(ASSET_ASSESSMENT_EVENTS.ANSWERED, {
            "Tag id": question?.tags[0],
            Question: question.data.title,
            ans: option?.option_value,
            "Page shown ": "Assests/Documents",
            "Application id": screenDetails.application_id,
        })

        setSelectedOption(option?.option_value)
        const answerObj = {
            answer_id: [`${option.option_id}`],
            question_id: question.id,
            question_type: "Asset",
        }
        updateNewAnswers(answerObj)
    }

    useEffect(() => {
        question.data.options.forEach((option: any) => {
            if (option.is_selected && !selectedOption) {
                const answerObj = {
                    answer_id: [`${option.option_id}`],
                    question_id: question.id,
                    question_type: "Asset",
                }
                setSelectedOption(option.option_value)
                updateNewAnswers(answerObj)
            }
        })
    }, [question.data.options, question.id, selectedOption, updateNewAnswers])

    // Reset selected when new question comes
    useEffect(() => {
        setSelectedOption("")
    }, [currentStep])

    return (
        <>
            <div className="flex justify-between" key={question.id}>
                <Typography variant="body2" className="text-onSurface-primary">
                    {question.data.title}
                </Typography>
                <div className="flex gap-x-2">
                    {question?.data?.options.map(
                        (option: any, index: Key | null | undefined) => {
                            return (
                                <div key={index}>
                                    <button
                                        className={clsx(
                                            "border border-solid text-onSurface-primary px-2 py-1 text-xs cursor-pointer",
                                            {
                                                "border-green-700 bg-green-50":
                                                    selectedOption ===
                                                    option?.option_value,
                                                "border-onSurface-disabled":
                                                    selectedOption !==
                                                    option?.option_value,
                                            }
                                        )}
                                        style={{ borderRadius: "100px" }}
                                        onClick={() => handleButtonClick(option)}
                                    >
                                        {option.option_value}
                                    </button>
                                </div>
                            )
                        }
                    )}
                </div>
            </div>
            {index !== questionsArray.length - 1 && (
                <div className="border-x-onSurface-disabled border-[1px] border-solid my-4" />
            )}
        </>
    )
}

export default RenderAssetQuestion
